import lodash from 'lodash';
import { dispatch, getState } from '../../store/Index';
import { generalShowErrorSnackbar } from '../../store/general/Functions';
import axios from 'axios';
import { dataSetRights } from '../../store/data/Actions';
import { IRight } from '../../@types/model/user/right';
import { IMappedRight } from '../../@types/model/user/mappedRight';
import { setArrayElement, addArrayElement } from '../appFunctionsService';
import { IApiError } from '../../@types/other';

export async function getList(name ?: string, code ?: string, isActive ?: boolean) : Promise<Array<IRight>> {
    try {
        const result = await axios.get<Array<IRight>>(`${API_URL}/v1/Rights/Right/GetList`, {
            params : {
                name,
                code,
                isActive,
            },
        });

        dispatch(dataSetRights(result.data));

        return result.data;
    } catch (ex) {
        const error = ex as IApiError;
        if (!!error && error.status === 400) {
            generalShowErrorSnackbar(error.data?.Message ?? '');
        } else if (!!error && error.status !== 401 && error.status !== 403) {
            generalShowErrorSnackbar('Error getting rights');
        }
        return [];
    }
}

export async function addOrUpdateRights(data : IRight) : Promise<IRight | null> {
    try {
        const state = getState();

        const result = await axios.post<IRight>(`${API_URL}/v1/Rights/Right/PostRight`, data);

        const position = state.data.rights.findIndex(x => x.id === result.data.id);
        if (position !== -1) {
            dispatch(dataSetRights(setArrayElement(state.data.rights, position, result.data)));
        } else {
            dispatch(dataSetRights(addArrayElement(state.data.rights, result.data)));
        }

        return result.data;
    } catch (ex) {
        const error = ex as IApiError;
        if (!!error && error.status === 400) {
            generalShowErrorSnackbar(error.data?.Message ?? '');
        } else if (!!error && error.status !== 401 && error.status !== 403) {
            generalShowErrorSnackbar('An error occured while saving the right.');
        }
        return null;
    }
}

export function mapRightsToMappedRights(rights : Array<IRight>) : Array<IMappedRight> {
    const result : Array<IMappedRight> = [];

    rights.forEach((n) => {
        if (!!!n.parentId) {
            result.push({
                id: n.id,
                code: n.code,
                name: n.name,
                url: n.url,
                isMobile: n.isMobile,
                isMenu: n.isActive, // TODO: confirm this?
                children: mapRightChildrenToMappedRights(rights, n.id),
            });
        }
    });

    return result;
}

function mapRightChildrenToMappedRights(rights : Array<IRight>, parentId ?: number) : Array<IMappedRight> {
    const result : Array<IMappedRight> = [];

    const children = lodash.filter(rights, n => n.parentId === parentId);

    children.forEach((n) => {
        result.push({
            id: n.id,
            code: n.code,
            name: n.name,
            url: n.url,
            isMobile: n.isMobile,
            isMenu: n.isActive, // TODO: confirm this?
            children: mapRightChildrenToMappedRights(rights, n.id),
        });
    });

    return result;
}

export function hasMenuRight(url : string) : boolean {
    const state = getState();

    if (!state.auth.session) return false;

    if (!state.auth.session.user.rights || !state.auth.session.user.rights.length) return false;

    const { rights } = state.auth.session.user;
    return rights.some(n => n.url === url);
}
